import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '@/components/Navbar';
import { Button } from '@/components/ui/button';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="container mx-auto px-4 md:px-6 max-w-4xl py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Torna alla Home
          </Button>
        </Link>

        <h1 className="text-4xl font-extrabold mb-8">Privacy Policy</h1>

        <div className="prose prose-gray max-w-none space-y-6">
          <p className="text-gray-600">
            <strong>Ultimo aggiornamento:</strong> 28 Dicembre 2025
          </p>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">1. Titolare del Trattamento</h2>
            <p>
              Il titolare del trattamento dei dati personali è <strong>Civaie - Di Lelmi Luciana</strong>, 
              con 40 anni di attività nel settore pet shop e giardinaggio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">2. Dati Raccolti</h2>
            <p>Durante la registrazione e l'utilizzo del servizio, raccogliamo i seguenti dati:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Dati identificativi:</strong> nome, cognome, email</li>
              <li><strong>Dati di contatto:</strong> numero di telefono, indirizzo (opzionali)</li>
              <li><strong>Dati di navigazione:</strong> indirizzi IP, dati di log</li>
              <li><strong>Dati degli ordini:</strong> prodotti acquistati, importi, modalità di pagamento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">3. Finalità del Trattamento</h2>
            <p>I tuoi dati personali vengono trattati per le seguenti finalità:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gestione della registrazione e autenticazione utente</li>
              <li>Elaborazione e gestione degli ordini</li>
              <li>Comunicazioni relative agli ordini e servizi richiesti</li>
              <li>Invio di newsletter e comunicazioni promozionali (solo con il tuo consenso)</li>
              <li>Adempimento di obblighi legali e contabili</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">4. Base Giuridica</h2>
            <p>Il trattamento dei dati è basato su:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Esecuzione del contratto:</strong> per gestire i tuoi ordini</li>
              <li><strong>Consenso:</strong> per l'invio di comunicazioni marketing</li>
              <li><strong>Obblighi di legge:</strong> per adempimenti fiscali e contabili</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">5. Conservazione dei Dati</h2>
            <p>
              I dati personali vengono conservati per il tempo necessario a fornire i servizi richiesti 
              e per adempiere agli obblighi di legge (generalmente 10 anni per i dati contabili).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">6. I Tuoi Diritti</h2>
            <p>In conformità al GDPR, hai diritto a:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Accesso:</strong> ottenere conferma dei dati trattati</li>
              <li><strong>Rettifica:</strong> correggere dati inesatti</li>
              <li><strong>Cancellazione:</strong> richiedere la cancellazione dei dati</li>
              <li><strong>Limitazione:</strong> limitare il trattamento</li>
              <li><strong>Portabilità:</strong> ricevere i dati in formato strutturato</li>
              <li><strong>Opposizione:</strong> opporti al trattamento per finalità di marketing</li>
              <li><strong>Revoca del consenso:</strong> in qualsiasi momento</li>
            </ul>
            <p className="mt-4">
              Per esercitare i tuoi diritti, contattaci tramite il nostro negozio o via email.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">7. Sicurezza</h2>
            <p>
              Adottiamo misure tecniche e organizzative adeguate per proteggere i tuoi dati personali 
              da accessi non autorizzati, perdita o distruzione.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">8. Cookie</h2>
            <p>
              Utilizziamo cookie tecnici necessari per il funzionamento del sito. 
              Non utilizziamo cookie di profilazione senza il tuo consenso esplicito.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">9. Modifiche alla Privacy Policy</h2>
            <p>
              Ci riserviamo il diritto di modificare questa privacy policy in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina con la data di aggiornamento.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4">10. Contatti</h2>
            <p>
              Per qualsiasi domanda o richiesta relativa alla presente privacy policy, 
              puoi contattarci presso il nostro negozio o tramite i contatti disponibili sul sito.
            </p>
          </section>
        </div>
      </div>

      <footer className="bg-gray-900 text-white py-12 mt-16">
        <div className="container mx-auto px-4 md:px-6 max-w-7xl text-center">
          <p className="text-lg font-semibold mb-2">Civaie - Di Lelmi Luciana</p>
          <p className="text-gray-400 text-sm">40 anni di attività</p>
        </div>
      </footer>
    </div>
  );
}